
import React, { Component } from "react";
import { injectIntl, defineMessages, FormattedMessage, } from "react-intl";

const messages = defineMessages({
    myNameIs: {
        id: 'app.animal.myNameIs',
        defaultMessage: 'I \'m'
    }
})

class AnimalBioSmall extends Component {
    render() {
        const { intl: { formatMessage } } = this.props
        return <div>
            {this.props.story.name && `${this.props.story.name} `}
            {this.props.story.breed && `${this.props.story.breed} `}
            {this.props.story.age && `${this.props.story.age}`}
        </div>
    }

}

export default injectIntl(AnimalBioSmall)


